import React, { useState, useEffect } from 'react';
import { Container, IconButton, Box, Button } from '@mui/material';
import DataTable from '../components/DataTable';
import PageTitle from '../components/PageTitle';
import { useConfirm } from '../assets/contexts/confirmContext';
import { useNotification } from '../assets/contexts/notificationContext';
import Loader from '../components/loader';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { ACTION_ICON_COLORS } from '../constants/iconActionColors';
import * as endPoints from '../assets/js/endpoints';
import { Helmet } from 'react-helmet';

const ManageMedia = () => {
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const confirm = useConfirm();
  const { showNotification } = useNotification();

  const fetchFiles = async () => {
    try {
      setLoading(true);
      const data = await endPoints.getMedia();
      setFiles(Array.isArray(data) ? data : data.data);
    } catch (_err) {
      showNotification('Error obteniendo archivos', 'error');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFiles();
  }, []);


  const handleDelete = async path => {
    const ok = await confirm('¿Eliminar archivo?');
    if (!ok) return;
    try {
      await endPoints.deleteMedia(path);

      fetchFiles();
      showNotification('Archivo eliminado', 'success');
    } catch (_err) {
      showNotification('Error eliminando archivo', 'error');
    }
  };

  const handleUpload = async e => {
    const file = e.target.files?.[0];
    if (!file) return;
    try {
      setLoading(true);
      await endPoints.uploadMedia(file);
      fetchFiles();
      showNotification('Archivo subido', 'success');
    } catch (_err) {
      showNotification('Error subiendo archivo', 'error');
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    { id: 'preview', label: 'Imagen',  sortable: false  },
    { id: 'path', label: 'Ruta' },
    { id: 'size', label: 'Tamaño' },
  ];

  const rows = files.map(f => ({
      ...f,
      preview: <img src={f.url} alt={f.path} style={{ width: 60, height: 60, objectFit: 'cover' }} />
    }));

  const actions = file => (
    <>
      <IconButton component="a" href={file.url} target="_blank" sx={{ color: ACTION_ICON_COLORS.see }}>
        <VisibilityIcon />
      </IconButton>
      <IconButton onClick={() => handleDelete(file.path)} sx={{ color: ACTION_ICON_COLORS.delete }}>
        <DeleteIcon />
      </IconButton>
    </>
  );

  return (
    <>
      <Helmet>
        <title>Gestión de Multimedia | CES</title>
      </Helmet>
      <Container sx={{ mt:5, paddingBottom:2, mb:2 }}>
        <Box sx={{ display:'flex', justifyContent:'space-between', alignItems:'center', mb:2 }}>
          <PageTitle>Gestión de Multimedia</PageTitle>
          <Button variant="contained" component="label" startIcon={<AddIcon />}>
            Subir Archivo
            <input hidden type="file" onChange={handleUpload} />
          </Button>
        </Box>
        {loading ? <Loader /> : <DataTable columns={columns} rows={rows} actions={actions} />}
      </Container>
    </>
  );
};

export default ManageMedia;
